// Scroll reveal
const io = new IntersectionObserver(
  (entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  },
  {threshold: 0.15, rootMargin: '0px 0px -60px 0px'},
);
document.querySelectorAll('.features, .tile, .card, .gal-card, .step, .plan-col, .figure-card, .compare-wrap, .data-box, .trust, .premium-note, .gallery-group, .section-title, .section-sub').forEach((el) => {
  el.classList.add('reveal');
  io.observe(el);
});

// FAQ accordion
document.querySelectorAll('.faq-q').forEach((btn) => {
  btn.addEventListener('click', () => {
    const item = btn.parentElement;
    const ans = btn.nextElementSibling;
    const isOpen = item.classList.toggle('open');
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (isOpen) {
      ans.style.maxHeight = ans.scrollHeight + 'px';
    } else {
      ans.style.maxHeight = '0px';
    }
  });
});

// Smooth-scroll offset for fixed nav
document.querySelectorAll('a[href^="#"]').forEach((a) => {
  a.addEventListener('click', (e) => {
    const id = a.getAttribute('href');
    if (id.length > 1) {
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        const y = el.getBoundingClientRect().top + window.pageYOffset - 60;
        window.scrollTo({top: y, behavior: 'smooth'});
      }
    }
  });
});

// Mobile burger (class toggle)
const burger = document.querySelector('.nav-burger');
const menu = document.querySelector('.nav-menu');
if (burger && menu) {
  burger.addEventListener('click', () => {
    menu.classList.toggle('is-open');
  });

  // Close menu when link is clicked (mobile)
  menu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      menu.classList.remove('is-open');
    });
  });

  // Clean up on resize
  window.addEventListener('resize', () => {
    if (window.innerWidth > 768) {
      menu.classList.remove('is-open');
    }
  });
}

// Gallery tab filter
const galTabs = document.querySelectorAll('.gal-tab');
const galCards = document.querySelectorAll('.gal-card');
galTabs.forEach((tab) => {
  tab.addEventListener('click', () => {
    galTabs.forEach((t) => t.classList.remove('is-active'));
    tab.classList.add('is-active');
    const f = tab.dataset.filter;
    galCards.forEach((c) => {
      const cats = (c.dataset.cat || '').split(' ');
      const match = f === 'all' || cats.includes(f);
      c.classList.toggle('is-hidden', !match);
    });
  });
});

// Lightbox for gallery
const lb = document.getElementById('lightbox');
const lbImg = document.getElementById('lbImg');
const lbTitle = document.getElementById('lbTitle');
const lbClose = document.getElementById('lbClose');
const lbPrev = document.getElementById('lbPrev');
const lbNext = document.getElementById('lbNext');
let lbIndex = 0;
const getVisibleCards = () => Array.from(galCards).filter((c) => !c.classList.contains('is-hidden'));
const openLb = (idx) => {
  const vis = getVisibleCards();
  if (!vis.length) return;
  lbIndex = ((idx % vis.length) + vis.length) % vis.length;
  const c = vis[lbIndex];
  lbImg.src = c.dataset.img;
  lbImg.alt = c.dataset.title;
  lbTitle.textContent = c.dataset.title;
  lb.classList.add('is-open');
  lb.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
};
const closeLb = () => {
  lb.classList.remove('is-open');
  lb.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
};
galCards.forEach((c, i) => {
  c.addEventListener('click', () => {
    const vis = getVisibleCards();
    const pos = vis.indexOf(c);
    if (pos >= 0) openLb(pos);
  });
});
if (lbClose) lbClose.addEventListener('click', closeLb);
if (lb)
  lb.addEventListener('click', (e) => {
    if (e.target === lb) closeLb();
  });
if (lbPrev)
  lbPrev.addEventListener('click', (e) => {
    e.stopPropagation();
    openLb(lbIndex - 1);
  });
if (lbNext)
  lbNext.addEventListener('click', (e) => {
    e.stopPropagation();
    openLb(lbIndex + 1);
  });
document.addEventListener('keydown', (e) => {
  if (!lb || !lb.classList.contains('is-open')) return;
  if (e.key === 'Escape') closeLb();
  else if (e.key === 'ArrowLeft') openLb(lbIndex - 1);
  else if (e.key === 'ArrowRight') openLb(lbIndex + 1);
});
